import { Header } from 'containers/Welcome/fragments/MainSection/core';
import { isAuth } from 'utils/configs';
import Routes from 'routes/index';
import { ScrollToTopButton } from 'components';
import styled from 'styled-components/macro';

export const CustomerRoutes = () => (
  <>
    <Header isAuth={isAuth} />
    <RoutContainer>
      <Routes />
    </RoutContainer>
    <ScrollToTopButton />
  </>
);

const RoutContainer = styled.div`
  min-height: calc(100vh - 232px);
`;
